import React, { useState } from 'react';
import { Modal, Typography, Box, Backdrop, Button, Paper } from '@mui/material';
import { API, graphqlOperation } from 'aws-amplify';
import { deleteItemmaster } from '../../graphql/mutations';
import { LoadingButton } from '@mui/lab';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { useThemes } from '../Theme/theme';
import { getLastAuthUser } from '../../library/shared';
import { createItemMaster, getItemmaster } from '../../graphql';
import { useDispatch } from 'react-redux';
import { dashboardApi } from '../../redux/apis/dashboardApi';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  borderRadius: '4px',
};

const DeleteGoodsItem = ({
  open,
  setOpen,
  itemData,
  rows,
  setRows,
  setDeleteSuccessSnakbar,
  setWarningMsg,
  setdataCount,
  listItemDetails,
}) => {
  const { theme } = useThemes();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  async function deleteGoodsItemDet(data) {
    try {
      const response = await API.graphql(graphqlOperation(getItemmaster, { itemid: data.itemId }));
      const itemData = response?.data?.getItemmaster?.[0] || {};
      const comments = typeof itemData?.remarks === 'string' ? itemData?.remarks.split('\n') : [];
      let masterData = {
        currencycd: '13',
        hsnid: 0,
        itemid: itemData?.itemId || itemData?.itemid,
        itemcategorycd: itemData?.itemcategorycd ? itemData?.itemcategorycd : itemData?.itemCtegorey === '' ? 0 : itemData?.itemCtegorey,
        itemcode: itemData?.itemCode || itemData?.itemcode,
        itemname: itemData?.itemName || itemData?.itemname,
        itemtype: itemData?.itemtype ? itemData?.itemtype : itemData?.type === 1 ? 'GOODS' : 'SERVICE',
        measurementcd: itemData?.unit || itemData?.measurementcd,
        purchaseaccountid: itemData?.purchaseaccountid,
        purchaseinvoiceflag: itemData?.purchaseinvoiceflag,
        reversechargeflag: 0,
        salesaccountid: itemData?.salesaccountid,
        salesinvoiceflag: itemData?.salesinvoiceflag,
        taxabilitycd: itemData?.taxability?.value || itemData?.taxabilitycd || '',
        is_active: 1,
        serialnumber: itemData?.voucherSeries?.value || itemData?.serialnumber,
        expiredtimestamp: Math.floor(Date.now() / 1000),
        lastupdatedby: getLastAuthUser(),
        financialyearid: itemData?.financialyearid,
        companyid: itemData?.companyid,
        description: comments?.join('**'),
      };
      let res = await API.graphql(
        graphqlOperation(createItemMaster, {
          createItemMasterInput: masterData,
        })
      );
      if (res.data.createItemMaster === null) {
        showWarningSnackbar(res.data.deleteItemmaster.statusmessage);
        setLoading(false);
        setOpen(false);
      } else {
        if (res.data?.createItemMaster != null) {
          let arr = rows?.filter((item, ind) => {
            if (item.itemId != itemData?.id) {
              return item;
            }
          });
          if (setRows) {
            setRows(arr);
          }
          setOpen(false);
          if (listItemDetails) {
            listItemDetails();
          }
          showSuccessSnackbar('Item Deleted');
          dispatch(dashboardApi.util.invalidateTags(['Dashboard_itemMaster']));
          if (setdataCount) {
            setdataCount((prev) => prev - 1);
          }
        } else {
          alert('Item not Deleted.! something went wrong. please try again');
          setOpen(false);
        }
      }
    } catch (error) {
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showErrorSnackbar(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  const deleteItem = () => {
    setLoading(true);
    const itemRowData = itemData?.data;
    deleteGoodsItemDet(itemRowData);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>
        <Box
          sx={{
            borderRadius: '4px',
            padding: '15px',
            textAlign: 'center',
            overflowY: { xs: 'scroll', sm: 'hidden' },
            '.MuiTableCell-root': {
              padding: '10px 10px',
              fontSize: '13px',
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes('9') ? '#ffffff' : 'rgb(60 60 60)',
              fontWeight: 'bold',
            }}
          >
            Do you want to delete this Item?
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            // flexDirection: { xs: 'column', sm: 'row' },
            paddingLeft: '15px',
            paddingRight: '15px',
            paddingBottom: '15px',
          }}
        >
          <Button disabled={loading} onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '5px', fontSize: '12px' }}>
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: '5px', fontSize: '12px' }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteGoodsItem;
